const translatePassengersToPkg = (searchRequest, passengers) => {
  const travelers = Object.keys(searchRequest?.params || {}).reduce((acc, cur) => {
    const match = cur.match(new RegExp(/^num-(\w+)$/))
    if (match) {
      const value = parseInt(searchRequest.params[cur], 10)
      acc[match[1]] = !isNaN(value) ? value : 0
    }
    return acc
  }, {})

  // in case there is no param from the url, fallback to airPriceResponse graph call if exists
  if (!travelers.adults && passengers && typeof passengers === 'object') {
    const {
      ADULT = 0,
      MILITARY = 0,
      SENIOR_CITIZEN = 0,
      CHILD = 0,
      INFANT = 0,
      LAP_INFANT = 0,
      SEAT_INFANT = 0,
    } = passengers
    travelers.adults = ADULT + MILITARY + SENIOR_CITIZEN
    travelers.children = CHILD + SEAT_INFANT
    travelers.infants = INFANT + LAP_INFANT
  }

  // default to 1 adult and the rest of travelers to 0 if they don't exist in searchRequest
  if (!travelers.adults) {
    travelers.adults = 1
  }

  if (!travelers.infants) {
    travelers.infants = 0
  }

  if (!travelers.children) {
    travelers.children = 0
  }

  return travelers
}

export { translatePassengersToPkg }
